import { SHOW_MARKETING_CONSENT_CONFIG } from '@cx-web/repub-config';

import { type Repub } from '@cx-modules/constants';

import { views } from './constants';
import { type AuthFieldError } from './types';

/**
 * Helper to convert AuthFieldError to string for display in form inputs
 */
export function getFieldErrorMessage(error: AuthFieldError | string | undefined): string | undefined {
  if (!error) return undefined;
  if (typeof error === 'string') return error;
  return error.message;
}

/**
 * Reads marketing consent off an SSO form submission, or `undefined` when the question wasn't asked
 * (not a signup, or the repub doesn't show the checkbox) — `undefined` tells the caller to leave the
 * user's existing preference alone rather than overwrite it.
 */
export function resolveSsoMarketingConsent(repub: Repub, view: string, form: FormData): boolean | undefined {
  const isSignup = view === views.SIGN_UP;
  if (!isSignup || !SHOW_MARKETING_CONSENT_CONFIG[repub]) return undefined;
  return form.get('marketingConsent') === 'true';
}
